import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'

const COLUMNS = [
    {
        title: 'Product',
        links: [
            { href: '/#how-it-works', label: 'How it works' },
            { href: '/#features', label: 'Features' },
            { href: '/#templates', label: 'Templates' },
            { href: '/#faq', label: 'FAQ' }
        ]
    },
    {
        title: 'Studio',
        links: [
            { href: '/create', label: 'Create a post' },
            { href: '/posts', label: 'Your posts' },
            { href: '/feeds', label: 'Feeds' },
            { href: '/brand', label: 'Brand kit' }
        ]
    },
    {
        title: 'Account',
        links: [
            { href: '/signup', label: 'Sign up' },
            { href: '/login', label: 'Log in' },
            { href: '/privacy', label: 'Privacy' }
        ]
    }
]

export const SiteFooter: FC = (): ReactNode => (
    <footer className='border-t border-border bg-secondary/60'>
        <div className='mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.4fr_repeat(3,1fr)]'>
            <div className='flex flex-col gap-4'>
                <Logo />
                <p className='max-w-xs text-sm leading-relaxed text-muted-foreground'>
                    Blog posts in, scroll-stopping carousels out. Write, design and plan your Instagram posts in one place.
                </p>
            </div>

            {COLUMNS.map(column => (
                <nav key={column.title} aria-label={column.title} className='flex flex-col gap-3'>
                    <h2 className='font-sans text-sm font-semibold tracking-normal'>
                        {column.title}
                    </h2>

                    {column.links.map(link => (
                        <Link key={link.href} href={link.href} className='w-fit text-sm text-muted-foreground transition-colors hover:text-foreground'>
                            {link.label}
                        </Link>
                    ))}
                </nav>
            ))}
        </div>

        <div className='border-t border-border'>
            <div className='mx-auto flex max-w-6xl flex-col gap-2 px-5 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between sm:px-8'>
                <p>Feedsmith is an independent tool and is not affiliated with Instagram or Meta.</p>
                <p>Instagram is a trademark of Meta Platforms, Inc.</p>
            </div>
        </div>
    </footer>
)
